<template>
  <div class="food-card-component">
    <div class="badge-left d-flex flex-column align-center">
      <component :is="getLeftSticker" />
      <!--      <div class="d-flex flex-column align-center fox-coins" v-if="hasBonus">
        <icon-bonus />
        <span>+{{ item.foxCoinsAdd }}</span>
      </div>-->
    </div>

    <div class="badge-right d-flex flex-column align-center">
      <component :is="getRightSticker" />
    </div>

    <div class="card-image d-flex align-center justify-center">
      <img v-if="item.image" :src="item.image" alt="Food" />
      <font-awesome-icon v-if="!item.image" icon="utensils" />
    </div>

    <div class="footer">
      <!--      <div v-if="isDrink" class="liquid-volume">-->
      <!--        <v-btn-toggle v-model="liquidValue" class="d-flex align-center justify-space-between" dense group mandatory>-->
      <!--          <v-btn value="5" class="font-weight-medium" outlined :ripple="false">-->
      <!--            0.5 Л-->
      <!--          </v-btn>-->
      <!--          <v-btn value="9" class="font-weight-medium" outlined :ripple="false">-->
      <!--            0.9 Л-->
      <!--          </v-btn>-->
      <!--        </v-btn-toggle>-->
      <!--      </div>-->
      <div class="card-info d-flex justify-space-between">
        <span class="title font-weight-medium text-uppercase">{{ item.name }}</span>
        <span class="price font-weight-medium">{{ getItemPrice }}</span>
      </div>

      <v-btn
        v-if="!showCounter"
        class="button-add font-weight-medium"
        color="#FF9500"
        dark
        circle
        fab
        depressed
        @click="addItem"
      >
        <font-awesome-icon icon="plus" />
        Добавить
      </v-btn>

      <div v-if="showCounter" class="counter d-flex align-center justify-space-between">
        <v-btn v-if="getCount === 1" class="button button-delete" @click="decreaseItem">
          <font-awesome-icon icon="times" />
        </v-btn>
        <v-btn v-if="getCount > 1" class="button button-minus" @click="decreaseItem">
          <font-awesome-icon icon="minus" />
        </v-btn>
        <span class="count">{{ getCount }}</span>
        <v-btn class="button button-plus" @click="addItem">
          <font-awesome-icon icon="plus" />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinGetFoodStickers from '@/mixins/get-food-stickers'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'UpsaleItem',
    mixins: [mixinGetFoodStickers, mixinSnackbarMessage],
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      isDrink: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        liquidValue: '5',
      }
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
      }),
      showCounter () {
        return this.basket.items.find(item => item.menuItemId === this.item.id) || false
      },
      getCount () {
        const items = this.basket.items.filter(item => item.menuItemId === this.item.id)
        return items.length || 0
      },
      getItemPrice () {
        return this.item.price ? this.item.price + ' ₽' : '0 ₽'
      },
      hasBonus () { return this.item.foxCoinsAdd },
    },
    methods: {
      openFoodWindow () {
        this.$emit('openFoodWindow', this.item)
      },
      decreaseItem () {
        const basketItem = this.basket.items.find(item => item.menuItemId === this.item.id) || null
        if (basketItem) {
          const id = basketItem.id
          this.$store.dispatch('baskets/deleteBasketItem', { id })
            .then(res => {
              if (res.status === 200) {
                this.$store.commit('baskets/setBasket', res.data.data)
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            })
        }
      },
      addItem () {
        const payload = {
          menuItemId: this.item.id,
        }
        this.$store
          .dispatch('baskets/addBasketItem', {
            data: payload,
            id: this.basket.id,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit('baskets/setBasket', res.data.data)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  .food-card-component {
    position: relative;
    overflow: hidden;
    padding-top: 10px;
    border-radius: 10px;
    background: #f1f3f6;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    z-index: 0;

    .badge-left {
      position: absolute;
      top: 15px;
      left: 8px;

      svg {
        margin-bottom: 10px;
      }

      .fox-coins {
        svg {
          margin-bottom: 0;
        }
        span {
          color: #ff9100;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    .badge-right {
      position: absolute;
      top: 15px;
      right: 26px;

      svg {
        margin-bottom: 10px;
      }
    }

    .card-image {
      width: 100%;
      height: 182px;
      text-align: center;
      cursor: pointer;
      object-fit: contain;

      svg {
        width: 70px;
        height: 70px;
        opacity: 0.4;
        .fill-svg(@color-primary);
      }

      img {
        width: 250px;
        height: 182px;
        object-fit: contain;
      }
    }

    .footer {
      padding: 11px 20px 15px 16px;

      .liquid-volume {
        margin-bottom: 16px;

        button {
          border-radius: 10px !important;
          max-width: 100px;
          width: 100%;
          font-size: 15px;
          border: 1px solid transparent !important;
          &.v-item--active {
            background-color: transparent !important;
            border-color: #0033FF !important;
            &:before {
              display: none;
            }
          }
        }
      }

      .card-info {
        margin-bottom: 10px;

        .title,
        .price {
          display: block;
        }

        .title {
          font-size: 15px;
          line-height: 20px;
        }

        .price {
          font-size: 21px;
          line-height: 20px;
          flex-shrink: 0;
        }
      }

      .counter {
        .count {
          font-size: 29px;
        }
        .button {
          height: 60px;
          border-radius: 10px;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
          svg {
            width: 20px;
            height: 20px;
          }
        }
        .button-plus, .button-minus {
          svg {
            .fill-svg(@color-primary);
          }
        }
        .button-delete {
          svg {
            .fill-svg(@color-error);
          }
        }
      }

      .button-add {
        border-radius: 10px;
        background-color: @color-primary !important;
        width: 100%;
        height: 60px;
        font-size: 15px;

        svg {
          margin-right: 10px;
        }
      }
    }
  }
</style>
